document.addEventListener("DOMContentLoaded", () => {
  console.log("🩵 Fixing Debutify image-with-text visibility");

  // Forceer zichtbaar maken van alle image-with-text secties
  document.querySelectorAll(".dbtfy-image-with-text img.media").forEach(img => {
    img.style.opacity = "1";
    img.style.visibility = "visible";
    img.style.transform = "none";
    img.closest(".media-wrapper").style.overflow = "visible";
    img.closest(".media-wrapper").style.height = "auto";
  });

  // Zet ambient-movement animaties uit (die veroorzaken onzichtbare lagen)
  document.querySelectorAll(".ambient-movement-right, .ambient-movement-left, .ambient-movement").forEach(el => {
    el.classList.remove("ambient-movement-right", "ambient-movement-left", "ambient-movement");
  });

  // Start Debutify-secties opnieuw zodat content wordt geladen
  document.dispatchEvent(new CustomEvent("debutify:section:load"));
  document.dispatchEvent(new CustomEvent("shopify:section:load"));
});

// Extra check na load
window.addEventListener("load", () => {
  setTimeout(() => {
    document.querySelectorAll(".dbtfy-image-with-text img.media").forEach(img => {
      img.style.opacity = "1";
      img.style.visibility = "visible";
    });
    console.log("✅ Image-with-text visibility fix complete");
  }, 500);
});
